import { Link, useNavigate } from 'react-router-dom'
import { useEffect, useContext } from "react"
import { FaHome } from 'react-icons/fa';
import AuthContext from '../../context/auth/AuthContext';
import {
  IconCircleDashedNumber1,
  IconCircleDashedNumber2,
  IconCircleDashedNumber3,
  IconCircleDashedNumber4,
  IconCircleDashedNumber5,
  IconCircleDashedNumber6,
  IconCircleDashedNumber7,
  IconCircleDashedNumber8,
  IconCircleDashedNumber9,
  IconCircle1,
  IconCircle2,
  IconCircle3,
  IconCircle4,
  IconCircle5,
  IconCircle6,
  IconCircle7,
  IconCircle8,
  IconCircle9,
} from '@tabler/icons-react';

const Header = () => {
    
    const dashedIcons = [
        IconCircleDashedNumber1,
        IconCircleDashedNumber2,
        IconCircleDashedNumber3,
        IconCircleDashedNumber4,
        IconCircleDashedNumber5,
        IconCircleDashedNumber6,
        IconCircleDashedNumber7,
        IconCircleDashedNumber8,
        IconCircleDashedNumber9,
    ];
      
    const groupIcons = [IconCircle1, IconCircle2, IconCircle3, IconCircle4, IconCircle5, IconCircle6, IconCircle7, IconCircle8, IconCircle9];
    const { user, dispatch } = useContext(AuthContext);
    const message_balance = user?.branch.message_balance
    const payroll = user?.branch.payroll
    const branch = user?.branch

  const navigate = useNavigate()
  
  useEffect(() => {
    const publicPaths = ['/privacy'];
    if (user === null && !publicPaths.includes(window.location.pathname)){
      navigate('/login')
    }

  }, []);


  const handleLogout = () => {
      dispatch({ type: 'LOGOUT'});
      navigate("/login"); // Redirect to login page
  };

  const handleLogin = () => {
    navigate("/login"); // Redirect to login page
  };

  return ( <div className="sticky-top">
  <header className="navbar navbar-expand-md sticky-top d-print-none" >
    <div className="container-xl">
      <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbar-menu" aria-controls="navbar-menu" aria-expanded="false" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon"></span>
      </button>
      <h1 className="navbar-brand navbar-brand-autodark d-none-navbar-horizontal pe-0 pe-md-3">
        <a href=".">
          <img src="/dist/img/logo/ubs2.png" width="110" height="32" alt="Tabler" className="navbar-brand-image"/>
        &nbsp;  KOBCIYE UBS
        </a>
      </h1>
      <div className="navbar-nav flex-row order-md-last">
        <div className="nav-item dropdown">
          <a href="#" className="nav-link d-flex lh-1 text-reset p-0" data-bs-toggle="dropdown" aria-label="Open user menu">
          <img src="/dist/img/profile/user.png" width="110" height="32" alt="Tabler" className="navbar-brand-image"/>
            <div className="d-none d-xl-block ps-2">
              <div>{user?.username}</div>
              <div className="mt-1 small text-muted">{user?.role?.name}</div>
            </div>
          </a>
          <div className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
              {user ? (
                <>
                  <span className="dropdown-item" onClick={handleLogout}>Logout</span>
                  <Link to="/change-password" className="dropdown-item">
                    Change Password
                  </Link>
                </>
              ) : (
                  <span className="dropdown-item" onClick={handleLogin}>Login</span>
              )}
          </div>
        </div>
      </div>
    </div>
  </header>
{user ?
  <header className="navbar-expand-md">
    <div className="collapse navbar-collapse" id="navbar-menu">
      <div className="navbar">
        <div className="container-xl">
            <ul className="navbar-nav">
                <li className="nav-item">
                    <a className="nav-link" href="./">
                    <span className="nav-link-icon d-md-none d-lg-inline-block"><FaHome /></span>
                    <span className="nav-link-title">Home</span>
                    </a>
                </li>
                {user?.menus?.map((mainGroup, index) => {
                    const GroupIcon = groupIcons[index] || IconCircle1;
                    return (
                    <li key={mainGroup.id} className="nav-item dropdown">
                    <a className="nav-link dropdown-toggle show" href="#navbar-base" data-bs-toggle="dropdown" role="button" aria-expanded="true">
                        <span className="nav-link-icon d-md-none d-lg-inline-block">
                        <GroupIcon stroke={2} />
                        </span>
                        <span className="nav-link-title">{mainGroup.group}</span>
                    </a>
                    <div className="dropdown-menu" data-bs-popper="none">
                        <div className="dropdown-menu-columns">
                        {mainGroup.groups
                            .sort((a, b) => b.items.length - a.items.length) // 👈 Sort subGroups by item count
                            .map((subGroup, i) => (
                            <div key={i} className="dropdown-menu-column">
                                {subGroup.title && <h4>&nbsp; {subGroup.title}</h4>}
                                {subGroup.items.map((item, j) => {
                                const Icon = dashedIcons[j] || IconCircleDashedNumber1;
                                return (
                                    <Link key={j} className="dropdown-item" to={item.path}>
                                    <Icon stroke={2} /> &nbsp; {item.label}
                                    </Link>
                                );
                                })}
                            </div>
                            ))}
                        </div>
                    </div>
                    </li>
                );
                })}

            </ul>
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-1"></div>
      <div className="col-md-5">
        <h1 className="navbar-brand">
          Message Balance: {message_balance}
          <Link to="/sms-pricing">Buy Now</Link>
        </h1>
      </div>
      <div className="col-md-5">
        { payroll.balance > 0 && 
          <h1 className="navbar-brand text-danger">Payroll: {payroll.balance} <Link to="/pay-branch-payroll" state={{ payload: 
            {
              previous_balance: payroll.previous_balance,
              debit: payroll.debit,
              credit: payroll.credit,
              balance: payroll.balance,
              transaction_fee: payroll.transaction_fee,
              year: payroll.year,
              month: payroll.month,
              public_id: branch.public_id
            }
          }}
        >Pay Now</Link></h1>
        }
      </div>
      <div className="col-md-1"></div>
    </div>
  </header>
  :<></>}
</div>)
}

export default Header
